import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import {
  Container,
  Wrapper,
  Image,
  Title,
  Text,
  EmailAddress,
  OtherButton,
  SpacerLine,
  ResendWrapper,
  NoEmailText,
  ResendButton,
} from './elements';
import AuthenticationError from '../../common/AuthenticationError';
import { useText, useLink, useConfig } from 'common/hooks';

const deps = {
  email: state.appContainer.auth.forgotPasswordForm.email.value,
  isSendingEmail: state.account.isSendingPasswordEmail,
  forgotPasswordSubmitted: sequences`appContainer.auth.forgotPasswordSubmitted`,
};

export function CheckEmail({
  email,
  forgotPasswordSubmitted,
  isSendingEmail,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const link = useLink();
  const { staticUrl } = useConfig();

  return (
    <Container>
      <Wrapper>
        <Image alt={''} src={`${staticUrl}/images/email-icon.png`} />
        <Title as={'h1'}>{t('authentication.check_email_address')}</Title>
        <Text>{t('authentication.follow_instructions_reset')}</Text>
        <EmailAddress>{email}</EmailAddress>
        <OtherButton href={link(`forgotPassword`)}>
          {t('authentication.wrong_address')}
        </OtherButton>
        <AuthenticationError />
        <SpacerLine />
        <ResendWrapper>
          <NoEmailText>{t('authentication.not_received')}</NoEmailText>
          <ResendButton
            disabled={isSendingEmail}
            onClick={() => forgotPasswordSubmitted()}
          >
            {t('authentication.resend')}
          </ResendButton>
        </ResendWrapper>
      </Wrapper>
    </Container>
  );
}

export default connect(deps, CheckEmail);
